import { configureStore } from '@reduxjs/toolkit';
import workspaceStatusReducer from './workspaceStatusSlice'

export const store = configureStore({
	reducer: {
		workspaceStatus: workspaceStatusReducer,
	},
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
